export const normalizeHtmlStyles = (html: string): string => html.replace(/style="([^"]*)"/g, (_, style: string) => {
  const newStyle = style
    .split(';')
    .map((s: string) => s.trim())
    .filter((prop: string) => prop.startsWith('font-style') || prop.startsWith('font-weight'))
    .join('; ');

  return newStyle ? `style="${newStyle}"` : '';
});
